<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>

            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="success" class="search-btn" @click="handlerUp">批量启用</Button>
            <Button type="info" class="search-btn" @click="towoman">巾帼专区</Button>
            <Button type="info" class="search-btn" @click="tolg">零工市场</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="单位名称"
                prop="Cname"
              >
                <Input
                  v-model="formValidate.Cname" disabled
                ></Input>

              </FormItem>

              <FormItem
                label="职位名称"
                prop="Jobname"
              >
                <Input
                  v-model="formValidate.Jobname"
                  placeholder="请输入"
                ></Input>

              </FormItem>
              <FormItem
                label="职位类别"
                prop="Jabbreviation"
              >
                <el-cascader
                  v-model="formValidate.Jabbreviation"
                  placeholder="请选择"
                  :options="JabbreviationList"
                  filterable
                  clearable></el-cascader>
              </FormItem>
              <FormItem
                label="职位描述"
                prop="Jdescribe"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Jdescribe"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="招聘人数"
                prop="Jnum"
              >
                <Input
                  v-model="formValidate.Jnum"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="工作经验" prop="Jexperience">
                <el-select
                  v-model="formValidate.Jexperience"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJexperienceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="学历" prop="Jeducation">
                <el-select
                  v-model="formValidate.Jeducation"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJeducationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="薪资" prop="Jsalary">
                <el-select
                  v-model="formValidate.Jsalary"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJsalaryList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="薪资类型" prop="Jsalarytype">
                <el-select
                  v-model="formValidate.Jsalarytype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择薪资类型">
                  <el-option
                    v-for="item in jobJsalarytypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="薪资下限(元)" prop="Jsalarymin">
                <InputNumber v-model="formValidate.Jsalarymin" placeholder="请输入薪资下限" style="width:100%"></InputNumber>
              </FormItem>
              <FormItem label="薪资上限(元)" prop="Jsalarymax">
                <InputNumber v-model="formValidate.Jsalarymax" placeholder="请输入薪资上限" style="width:100%"></InputNumber>
              </FormItem>
              <FormItem label="用工类型" prop="Jworktype">
                <el-select v-model="formValidate.Jworktype" clearable placeholder="请选择用工类型">
                  <el-option v-for="item in jobJworktypeList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                </el-select>
              </FormItem>
              <FormItem label="用工形式" prop="Jemployform">
                <el-select v-model="formValidate.Jemployform" clearable placeholder="请选择用工形式">
                  <el-option v-for="item in jobJemployformList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                </el-select>
              </FormItem>
              <FormItem label="招聘形式" prop="Jrecruitform">
                <el-select v-model="formValidate.Jrecruitform" clearable placeholder="请选择招聘形式">
                  <el-option v-for="item in jobJrecruitformList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                </el-select>
              </FormItem>
              <FormItem label="联系关系" prop="Jcontactrel">
                <el-select v-model="formValidate.Jcontactrel" clearable placeholder="请选择联系人与发布单位关系">
                  <el-option v-for="item in jobJcontactrelList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                </el-select>
              </FormItem>
              <FormItem label="福利待遇" prop="Jwelfare">
                <el-select v-model="formValidate.Jwelfare" multiple placeholder="请选择福利待遇">
                  <el-option v-for="item in jobJwelfareList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
                </el-select>
              </FormItem>
              <FormItem label="福利其他" prop="Jwelfare_other">
                <Input v-model="formValidate.Jwelfare_other" placeholder="请填写其他福利，用逗号分隔"></Input>
              </FormItem>
              <FormItem label="工作时间" prop="Jworktime">
                <Input type="textarea" v-model="formValidate.Jworktime" placeholder="请输入工作时间"></Input>
              </FormItem>
              <FormItem label="工资支付" prop="Jsalarypay">
                <Input type="textarea" v-model="formValidate.Jsalarypay" placeholder="请输入工资支付说明"></Input>
              </FormItem>
              <FormItem label="用人单位" prop="Jemployerunit">
                <Input v-model="formValidate.Jemployerunit" placeholder="请输入用人单位(签合同单位全称)"></Input>
              </FormItem>
              <FormItem label="用工单位" prop="Jworkunit">
                <Input v-model="formValidate.Jworkunit" placeholder="请输入用工单位(实际工作单位全称)"></Input>
              </FormItem>
              <FormItem label="单位简介" prop="Jcompanyintro">
                <Input type="textarea" v-model="formValidate.Jcompanyintro" placeholder="请输入单位简介"></Input>
              </FormItem>
              <FormItem label="发布单位" prop="Jpublishunit">
                <Input v-model="formValidate.Jpublishunit" placeholder="请输入发布单位全称"></Input>
              </FormItem>
              <FormItem label="许可证号" prop="Jlicenseno">
                <Input v-model="formValidate.Jlicenseno" placeholder="请输入人力资源服务许可证号(经营性机构)"></Input>
              </FormItem>
              <FormItem label="性别" prop="Jsex">
                <el-select
                  v-model="formValidate.Jsex"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJsexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="年龄" prop="Jage">
                <el-select
                  v-model="formValidate.Jage"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="婚姻" prop="Jmarriage">
                <el-select
                  v-model="formValidate.Jmarriage"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJmarriageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="其他要求"
                prop="Jrequirement"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Jrequirement"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="工作地址"
                prop="Jaddress"
              >
                <Input
                  v-model="formValidate.Jaddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="开始时间" prop="Jstime">
                <DatePicker type="date" editable v-model="formValidate.Jstime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择开始时间"></DatePicker>
              </FormItem>

              <FormItem label="结束时间" prop="Jetime">
                <DatePicker type="date" editable v-model="formValidate.Jetime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择开始时间"></DatePicker>
              </FormItem>

              <FormItem label="类型" prop="Jtype">
                <el-select
                  v-model="formValidate.Jtype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in jobJtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系人"
                prop="Jlinkman"
              >
                <Input
                  v-model="formValidate.Jlinkman"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="Jphone"
              >
                <Input
                  v-model="formValidate.Jphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>

              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import {
  getjoblist,
  operationJob,
  changeJob,
  getjobstypeList
} from '@/api/scinfo/scinfo.js'

import { getsysparameterList } from '@/api/system/sys_parameter'

// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      jobstateList: [],
      jobJexperienceList: [],
      jobJeducationList: [],
      jobJsalaryList: [],
      jobJsexList: [],
      jobJageList: [],
      jobJstateList: [],
      jobJtypeList: [],
      jobJmarriageList: [],
      jobJsalarytypeList: [],
      jobJworktypeList: [],
      jobJemployformList: [],
      jobJrecruitformList: [],
      jobJcontactrelList: [],
      jobJwelfareList: [],
      JabbreviationList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
        Jobname: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur'
          }
        ],
        Jnum: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        Jabbreviation: [
          {
            type: 'array',
            required: true,
            message: '请选择工种',
            trigger: 'blur'
          }
        ],
        Jexperience: [
          {
            required: true,
            message: '请选择工作经验',
            trigger: 'change'
          }
        ],
        Jeducation: [
          {
            required: true,
            message: '请选择学历',
            trigger: 'change'
          }
        ],
        Jsalary: [
          {
            required: true,
            message: '请选择薪资',
            trigger: 'change'
          }
        ],
        Jsex: [
          {
            required: true,
            message: '请选择性别要求',
            trigger: 'change'
          }
        ],
        Jage: [
          {
            required: true,
            message: '请选择年龄要求',
            trigger: 'change'
          }
        ],
        Jmarriage: [
          {
            required: true,
            message: '请选择婚姻要求',
            trigger: 'change'
          }
        ],
        Jaddress: [
          {
            required: true,
            message: '工作地址不能为空',
            trigger: 'blur'
          }
        ],
        Jstime: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        Jetime: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change'
          }
        ],
        Jtype: [
          {
            required: true,
            message: '请选择职位类型',
            trigger: 'change'
          }
        ],
        Jphone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        Jlinkman: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ]
      },

      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },

        {
          title: '职位名称',
          key: 'Jobname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 180
        },
        {
          title: '单位名称',
          key: 'Cname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 250
        },
        {
          title: '人数',
          key: 'Jnum',
          align: 'center',
          sortable: true,
          width: 80
        },
        {
          title: '性别',
          key: 'Jsex_CN',
          align: 'center',

          sortable: true,
          width: 80
        },
        {
          title: '学历',
          key: 'Jeducation_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '工作经验',
          key: 'Jexperience_CN',
          align: 'center',
          sortable: true,
          width: 130
        },

        {
          title: '薪资',
          key: 'Jsalary_CN',
          align: 'center',
          sortable: true,
          width: 130
        },
        {
          title: '开始时间',
          key: 'Jstime',
          align: 'center',
          sortable: true,
          width: 180
        },
        {
          title: '结束时间',
          key: 'Jetime',
          align: 'center',
          sortable: true,
          width: 180
        },
        {
          title: '更新时间',
          key: 'Updatetime',
          align: 'center',
          sortable: true,
          width: 180
        },
        {
          title: '联系人',
          key: 'Jlinkman',
          align: 'center',
          sortable: true,
          width: 100
        },
        {
          title: '联系电话',
          key: 'Jphone',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '状态',
          key: 'handle',
          width: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: params.row.Jstate_col } }, params.row.Jstate_CN)
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            if (params.row.Jstate == 1) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '暂停'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            } else {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '启用'
                ),

                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        }
      ]
    }
  },
  methods: {

    // 获取TagTree

    getjoblist (key, value) {
      this.spinShow = true

      getjoblist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data
          this.pageTotal = res.data.count
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    handleRemove (index) {
      this.formValidate.args_items[index].status = 0
    },

    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },
    getjobspapamsList () {
      getsysparameterList('job_info', 'Jexperience').then(res => {
        if (res.data.code === 0) {
          this.jobJexperienceList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jeducation').then(res => {
        if (res.data.code === 0) {
          this.jobJeducationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsalary').then(res => {
        if (res.data.code === 0) {
          this.jobJsalaryList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsalarytype').then(res => {
        if (res.data.code === 0) {
          this.jobJsalarytypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jworktype').then(res => {
        if (res.data.code === 0) {
          this.jobJworktypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jemployform').then(res => {
        if (res.data.code === 0) {
          this.jobJemployformList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jrecruitform').then(res => {
        if (res.data.code === 0) {
          this.jobJrecruitformList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jcontactrel').then(res => {
        if (res.data.code === 0) {
          this.jobJcontactrelList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jwelfare').then(res => {
        if (res.data.code === 0) {
          this.jobJwelfareList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsex').then(res => {
        if (res.data.code === 0) {
          this.jobJsexList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jage').then(res => {
        if (res.data.code === 0) {
          this.jobJageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jmarriage').then(res => {
        if (res.data.code === 0) {
          this.jobJmarriageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jtype').then(res => {
        if (res.data.code === 0) {
          this.jobJtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getjobstypeList (value, level) {
      getjobstypeList(value, level).then(res => {
        if (res.data.code === 0) {
          this.JabbreviationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    changstate (paramsRow) {
      let params = {
        'Id': paramsRow.Id,
        'Jstate': paramsRow.Jstate
        }
      setTimeout(() => {
        changeJob(params, 'PUT').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            if (this.searchVal) {
              this.getjoblist(this.searchVal)
            } else {
              this.getjoblist()
            }
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }, 1000)
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getjobspapamsList()
      this.getjobstypeList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.Id) {
        this.formValidate = {
          Id: paramsRow.Id,
          Cname: paramsRow.Cname,
          Jobname: paramsRow.Jobname,
          Jabbreviation: paramsRow.Jabbreviation,
          Jdescribe: paramsRow.Jdescribe,
          Jnum: paramsRow.Jnum,
          Jexperience: paramsRow.Jexperience,
          Jeducation: paramsRow.Jeducation,
          Jsalary: paramsRow.Jsalary,
          Jsex: paramsRow.Jsex,
          Jage: paramsRow.Jage,
          Jrequirement: paramsRow.Jrequirement,
          Jaddress: paramsRow.Jaddress,
          Jstate: paramsRow.Jstate,
          Jstime: paramsRow.Jstime,
          Jetime: paramsRow.Jetime,
          Jtype: paramsRow.Jtype,
          Jlinkman: paramsRow.Jlinkman,
          Jphone: paramsRow.Jphone,
          Jmarriage: paramsRow.Jmarriage,
          Juid: paramsRow.Juid,
          Jcid: paramsRow.Jcid,
          Jsalarytype: paramsRow.Jsalarytype,
          Jsalarymin: paramsRow.Jsalarymin,
          Jsalarymax: paramsRow.Jsalarymax,
          Jworktype: paramsRow.Jworktype,
          Jemployform: paramsRow.Jemployform,
          Jrecruitform: paramsRow.Jrecruitform,
          Jcontactrel: paramsRow.Jcontactrel,
          Jwelfare: paramsRow.Jwelfare ? String(paramsRow.Jwelfare).split(',') : [],
          Jwelfare_other: paramsRow.Jwelfare_other,
          Jworktime: paramsRow.Jworktime,
          Jsalarypay: paramsRow.Jsalarypay,
          Jemployerunit: paramsRow.Jemployerunit,
          Jworkunit: paramsRow.Jworkunit,
          Jcompanyintro: paramsRow.Jcompanyintro,
          Jpublishunit: paramsRow.Jpublishunit,
          Jlicenseno: paramsRow.Jlicenseno
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.Jstime = moment(this.formValidate.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.Jetime = moment(this.formValidate.Jetime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            if (Array.isArray(this.formValidate.Jwelfare)) {
              this.formValidate.Jwelfare = this.formValidate.Jwelfare.join(',')
            }
            operationJob(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)

                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }

                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },

    handleReset (name) {
      this.$refs[name].resetFields()
    },

    handlerDelete () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中设备 `)) {
          operationJob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getjoblist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    // 删除
    delData (params) {
      if (confirm(`确定要删除 ${params.row.Jobname}`)) {
        // console.log(params.row.id)
        operationJob(
          {
            'id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },

    handleSearch () {
      this.getjoblist(this.searchVal)
    },
    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    towoman () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要将这些职位列入巾帼专区嘛？ `)) {
          changeJob({ 'id_list': this.tableSelectIdList, 'sarea': '4|1' }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    tolg () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要将这些职位列入零工市场嘛？ `)) {
          changeJob({ 'id_list': this.tableSelectIdList, 'sarea': '12|1' }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    handlerUp () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量启用这些职位 `)) {
          changeJob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getjoblist(this.searchVal)
                } else {
                  this.getjoblist()
                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getjoblist()
  }
}

</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
